import { render, staticRenderFns } from "./SweepsRules.vue?vue&type=template&id=40105506&scoped=true"
import script from "./SweepsRules.vue?vue&type=script&lang=js"
export * from "./SweepsRules.vue?vue&type=script&lang=js"
import style0 from "./SweepsRules.vue?vue&type=style&index=0&id=40105506&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40105506",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40105506')) {
      api.createRecord('40105506', component.options)
    } else {
      api.reload('40105506', component.options)
    }
    module.hot.accept("./SweepsRules.vue?vue&type=template&id=40105506&scoped=true", function () {
      api.rerender('40105506', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/dashboard/SweepsRules.vue"
export default component.exports